// extracted by mini-css-extract-plugin
module.exports = {"container":"alertbottom_container__Z5III","contentWrapper":"alertbottom_contentWrapper__7jCuR","close":"alertbottom_close__YzNsR"};